import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { VlDataService, VlHttpService, HTTPAPIConfig, APIConfigMapping } from 'shared-library';

@Injectable({
  providedIn: 'root'
})
export class PublishAppService {

  private timerSubscription!: Subscription;
  private actionCompletedSubject: Subject<{}> = new Subject<{}>();
  actionCompleted$ = this.actionCompletedSubject.asObservable();

  constructor(private http: HttpClient, 
    private route: ActivatedRoute,
    private dataService: VlDataService,
    private httpService: VlHttpService) { }

  startApiCalls(): Observable<any> {
    return new Observable((observer) => {
      try {
        this.timerSubscription = timer(0, 2 * 60 * 1000).subscribe(() => {
          this.getAPKDetails().subscribe(
            (response: any) => {
              observer.next(response);
            },
            (error: any) => {
              observer.error(error);
            }
          );
        });
      }
      catch(error) {
        console.error(error)
      }
    });
  }


  stopApiCalls(data: any): void {
    try {
      if (this.timerSubscription) {
        this.actionCompletedSubject.next(data)
        this.timerSubscription.unsubscribe();
      }
    }
    catch(error) {
      console.error(error)
    }
  }
  
  getAPKDetails() : any {
    try {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
        APIConfigMapping["GET_APK_DETAILS"]
      );
      const currentParams = { ...this.route.snapshot.queryParams };
      apiConfig.postData = {
        application_id:currentParams['id'],
        version: null
      };
      return this.httpService.placeAPICall(apiConfig)
    }
    catch(error) {
      console.error(error);
    }
  }

  private versionList = [];

  getVersionList(){
    return this.versionList;
  }



  getVersionHistoryList(): any{
    return new Observable((observer) => {
      const currentParams = { ...this.route.snapshot.queryParams };
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['PLAYSTORE_CERTIFICATE_LIST']);
      apiConfig.postData = {
        applicationId:currentParams['id'],
      };
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          observer.next(data);
          observer.complete();
        },
        error: (error: any) => {
          observer.error(error);
          observer.complete();
        }
      });
    })
  }




   addCertificateDetails(postData:any): Observable<any> {
     const currentParams = { ...this.route.snapshot.queryParams };
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['PLAYSTORE_CERTIFICATE']);
    postData.applicationId  = currentParams['id'],
    apiConfig.postData = postData;
    return  this.httpService.placeAPICall(apiConfig)
  }


}
